<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 1000">
		<div style="width: 500px">
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("connection") }}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close')" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="dialog-body">
				<div class="container">
					<span>{{ $t("connection-2") }}</span>
					<el-select
						style="width: 100%"
						multiple
						filterable
						v-model="selected_folders"
						:placeholder="$t('search')"
					>
						<el-option v-for="f in folders" :key="f.id" :label="f.name" :value="f.id" />
					</el-select>
				</div>
			</div>
			<div class="dialog-footer" style="width: 100%">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close')">
						{{ $t("cancel") }}
					</md-button>
					<md-button class="add" @click="connectDocument(connectId)">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("save") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"

export default {
	name: "connect-modal",
	props: ["show", "connectId"],
	data() {
		return {
			folders: [],
			flowchart_folders: [],
			selected_folders: [],
			loading: false
		}
	},
	watch: {
		connectId() {
			this.getDocumentFolders()
		}
	},
	created() {
		this.getFolders()
	},
	methods: {
		getFolders() {
			this.folders = []

			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/folders/getFolders",
					{},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					if (res.data.items !== null) {
						for (let i = 0; i < res.data.items.length; i++) {
							this.folders.push({
								id: res.data.items[i].id,
								name: res.data.items[i].name
							})
						}
					}
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		},
		getDocumentFolders() {
			this.selected_folders = []
			axios
				.get(process.env.VUE_APP_API_URL + "/api/flowchart/getFolders/" + this.connectId, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					res.data.folders.forEach(el => {
						this.selected_folders.push(el.id)
						this.flowchart_folders.push(el.id)
					})
				})
				.catch(err => {})
		},
		connectDocument(id) {
			var payload = {
				flowchart: id,
				folders: this.selected_folders
			}
			axios
				.post(process.env.VUE_APP_API_URL + "/api/folders/connectToFolders", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.$notification("success", this.$t("doc-connected"), "", 4000)
					this.$emit("refresh", this.$route.params.id)
					this.$emit("close")
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
				})
		}
	}
}
</script>
<style lang="scss">
@import "@/assets/scss/documents.scss";
</style>
